import React from "react"
import types from "prop-types"
import { UserActionAuditTrailContextProvider } from "contexts/UserActionAuditTrailContext"
import Content from "./Content"

const ActionsTab = ({ user }) => {
  const { id: userId } = user

  return (
    <UserActionAuditTrailContextProvider userId={userId}>
      <h2 className="tab-title">Actions</h2>
      <Content />
    </UserActionAuditTrailContextProvider>
  )
}

ActionsTab.propTypes = {
  user: types.object.isRequired,
}

export default ActionsTab
